import React, { useState } from "react";
import { Search, Loader2, X, RotateCcw, Filter, ChevronDown } from "lucide-react";

const CustomerFilters = ({ loading, onSearch }) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(inputValue);
    }
  };

  const handleReset = () => {
    setInputValue("");
    onSearch("");
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-5">
      <div className="flex gap-2 w-full sm:max-w-xl items-center">
        <div className="relative flex-1 group">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {loading ? (
              <Loader2 size={18} className="text-blue-500 animate-spin" />
            ) : (
              <Search size={18} className="text-slate-400 group-focus-within:text-blue-500" />
            )}
          </div>

          <input
            type="text"
            placeholder="Nhấn Enter để tìm khách hàng..."
            className="block w-full pl-10 pr-10 py-2.5 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 outline-none shadow-sm transition-all bg-white"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />

          {inputValue && (
            <button
              onClick={() => setInputValue("")}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-red-500 transition-colors"
            >
              <X size={16} />
            </button>
          )}
        </div>

        {inputValue && (
          <button
            onClick={handleReset}
            className="p-2.5 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl transition-all shadow-sm flex items-center gap-2 group"
            title="Lấy lại dữ liệu gốc"
          >
            <RotateCcw size={18} className="group-hover:rotate-[-45deg] transition-transform" />
            <span className="text-xs font-bold hidden md:inline">Làm mới</span>
          </button>
        )}
      </div>

      <div className="flex gap-2 w-full sm:w-auto">
        <button className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-50">
          <Filter size={16} /> <span>Bộ lọc</span> <ChevronDown size={14} />
        </button>
      </div>
    </div>
  );
};

export default CustomerFilters;